import type { ReactNode } from 'react';

export type SearchMode = 'general' | 'actions' | 'caseId' | 'contacts' | 'myCases';

export type ResultCategory =
  | 'pinned'
  | 'activeToday'
  | 'myCases'
  | 'cases'
  | 'contacts'
  | 'customers'
  | 'recentActivity'
  | 'navigation';

export interface SearchResult {
  id: string;
  category: ResultCategory;
  title: string;
  subtitle?: string;
  badge?: string;
  icon?: ReactNode;
  onSelect: () => void;
}

export interface SearchProvider {
  category: ResultCategory;
  search: (query: string) => Promise<SearchResult[]> | SearchResult[];
  priority: number;
}

export interface PageContext {
  pathname: string;
  module:
    | 'cantrack'
    | 'contacts'
    | 'customers'
    | 'home'
    | 'other';
  subpage?: string;
}

export function parseMode(query: string): { mode: SearchMode; cleanQuery: string } {
  if (query.startsWith('>')) {
    return { mode: 'actions', cleanQuery: query.slice(1).trim() };
  }
  if (query.startsWith('#')) {
    const rest = query.slice(1).trim();
    if (/^\d*$/.test(rest)) {
      return { mode: 'caseId', cleanQuery: rest };
    }
  }
  if (query.startsWith('@')) {
    return { mode: 'contacts', cleanQuery: query.slice(1).trim() };
  }
  if (query.startsWith('!')) {
    return { mode: 'myCases', cleanQuery: query.slice(1).trim() };
  }
  return { mode: 'general', cleanQuery: query.trim() };
}
